import { Injectable, Inject, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable()
export class LoadingIndicatorsService {

    private _loading: boolean = false;
    loadingStatus: Subject<boolean> = new Subject();
    private renderer: Renderer2;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        rendererFactory: RendererFactory2
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }


    get loading(): boolean {
        return this._loading;
    }

    set loading(value) {
        this._loading = value;
        this.loadingStatus.next(value);
    }

    startLoading() {
        this.loading = true;
        this.renderer.addClass(this.document.body, 'si-loading-mask');
    }

    stopLoading() {
        this.loading = false;
        this.renderer.removeClass(this.document.body, 'si-loading-mask');
    }

}
